export const officeHoursCopy = {
  title: ['免费辅导预约', 'Free Office Hours'],
  introduction: ['选择 Matt 发布的完整时段。免费辅导不扣除课时，也不产生学费。', 'Choose a whole block published by Matt. Office hours are free and do not use lesson credits.'],
  timezone: ['所有时间均为中国标准时间（Asia/Shanghai，UTC+8）。', 'All times are China Standard Time (Asia/Shanghai, UTC+8).'],
  policy: ['本学期已使用免费辅导的学生，只能在开始前 48 小时内预约。仅按预约主学生的使用情况判断；每位学生最多有一个待进行的主预约。', 'Students who have used office hours this semester may book in the final 48 hours before start. Only the primary student determines this window; each student may have one upcoming primary reservation.'],
  cancelPolicy: ['开始前至少 24 小时取消不会影响首次使用优先权。更晚的已确认预约取消会计为主学生使用；待审批申请取消、拒绝或到期不会计为使用。', 'Cancellation at least 24 hours before start preserves unused priority. Later cancellation of a confirmed appointment counts as primary-student use. Cancelling, rejecting or expiring a pending request does not count as use.'],
  child: ['选择孩子', 'Choose your child'],
  available: ['可预约时段', 'Published blocks'],
  appointments: ['孩子的预约记录', 'Your child’s reservations'],
  emptyBlocks: ['当前没有发布的时段。', 'No blocks are currently published.'],
  emptyBookings: ['这位孩子还没有预约记录。', 'This child has no reservation history.'],
  loading: ['正在核实预约信息…', 'Checking booking information…'],
  refresh: ['刷新', 'Refresh'],
  unavailable: ['预约信息暂时无法核实。请重试。', 'Booking information could not be verified. Please retry.'],
  stale: ['以下是上次读取的信息，可能已变化。刷新成功前不能提交新预约或取消。', 'These are the last available details and may have changed. New bookings and cancellations are disabled until refresh succeeds.'],
  select: ['选择此时段', 'Select this block'],
  selected: ['已选择', 'Selected'],
  online: ['线上', 'Online'],
  offline: ['线下', 'In person'],
  meeting: ['会议链接', 'Meeting link'],
  location: ['地点', 'Location'],
  unknownTime: ['时间暂不可用', 'Time unavailable'],
  book: ['确认预约整个时段', 'Reserve this whole block'],
  request: ['提交搭档审批申请', 'Request partner approval'],
  partner: ['第二位学生', 'Second student'],
  choosePartner: ['请选择第二位学生', 'Choose the second student'],
  other: ['其他学生（需 Matt 审批）', 'Other student (Matt’s approval required)'],
  otherName: ['第二位学生姓名', 'Second student’s name'],
  approval: ['填写姓名后需 Matt 确认学生资格并审批。时段最多保留 12 小时，且不会超过预约开始时间；审批通过前并非已确认预约。', 'Matt must verify and approve every written-in partner. The block is held for up to 12 hours, ending by appointment start. It is not confirmed until approval succeeds.'],
  pending: ['等待 Matt 审批', 'Awaiting Matt’s approval'],
  confirmed: ['已确认', 'Confirmed'],
  expired: ['申请已到期，时段已释放', 'Request expired; the block was released'],
  rejected: ['申请已拒绝', 'Request rejected'],
  cancelled: ['已取消', 'Cancelled'],
  completed: ['已结束', 'Completed'],
  holdUntil: ['审批保留截止时间', 'Approval hold expires'],
  opensAt: ['可预约开始时间', 'Booking window opens'],
  cancel: ['取消此预约', 'Cancel this reservation'],
  cancelReason: ['取消原因', 'Reason for cancellation'],
  preservesUnused: ['按服务器当前核实，取消此预约不会计为使用。', 'The server’s current check says this cancellation will not count as use.'],
  countsPrimaryUse: ['按服务器当前核实，取消此已确认预约将计为主学生使用。', 'The server’s current check says cancelling this confirmed appointment will count as primary-student use.'],
  confirmCancel: ['确认取消', 'Confirm cancellation'],
  keep: ['保留预约', 'Keep reservation'],
  saving: ['正在提交…', 'Submitting…'],
  unknown: ['提交结果尚未确认。请使用下方按钮核实同一申请；核实期间保留原申请内容。', 'The submission result is unknown. Use the button below to recover the same request; its original details are retained until recovery.'],
  recover: ['核实同一申请', 'Recover the same request'],
  conflict: ['预约状态已变化。正在刷新；已保留填写内容，请核实最新状态后重试。', 'Booking state changed. Refreshing now; your draft is retained. Review the latest state before retrying.'],
  committed: ['申请已保存。最新预约信息如下。', 'Your request was saved. The latest reservation information appears below.'],
  calendarPending: ['日历同步尚未完成，预约以此页面的确认状态为准。', 'Calendar sync is pending. This page’s reservation state is authoritative.'],
  invalidResponse: ['服务器返回的信息不完整，请刷新核实。', 'The server response was incomplete. Refresh to verify the state.'],
  reserved: ['此时段已被预订', 'This block is reserved'],
  notEligible: ['这位孩子目前不符合本学期预约资格。', 'This child is not eligible for the current semester.'],
  upcomingLimit: ['这位孩子已有一个待进行的主预约。', 'This child already has an upcoming primary reservation.'],
  usageUnavailable: ['使用记录暂时无法核实，不能确认预约优先权。', 'Usage history could not be verified, so booking priority is unavailable.'],
  overlap: ['这位孩子在该时间已有其他辅导预约。', 'This child already participates in another appointment at this time.'],
  windowNotOpen: ['已使用过辅导，需等到此时段开始前 48 小时再预约。', 'Previous use means booking opens 48 hours before this block starts.'],
  returnPortal: ['返回学习进度', 'Learning progress'],
}

export function officeHoursText(key, language) {
  const entry = officeHoursCopy[key]
  return entry?.[language === 'cn' ? 0 : 1] || key
}
